<template>
    <div>
        <v-data-table :headers="headersTabela" :items="itens" hide-actions
                      class="az-table-list tabela-itens"
                      no-data-text="Não há informação disponível">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.sequencia }}
                </td>
                <td ref="coluna_descricao">
                    <expansao-texto :tamanho="tamanho" :texto="props.item.descricaoCompleta"/>
                </td>
                <td>
                    <span>
                        {{ `${props.item.codigoElementoSubElemento} - ${props.item.descricaoElementoSubElemento}` }}
                    </span>
                </td>
                <td align="right">
                    {{ props.item.descricaoUnidadeMedida }}
                </td>
                <td align="right">
                    {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
                </td>
                <td align="right">
                    {{ props.item.tipo }}
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'PainelLoteLegadoTabela',
    props: ['itens', 'casasDecimais', 'prefixOuSuffixValor', 'criterioJulgamento', 'isCriterioJulgamentoMaiorDesconto', 'possuiValorReferencia', 'casasDecimaisQuantidade'],
    data() {
        return {
            tamanho: null
        }
    },
    computed: {
        ...mapState(['loki']),
        headersTabela(){
            return [
                {
                    sortable: true,
                    value: 'sequencia',
                    text: 'Seq',
                    width: '5%',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    align: 'left',
                    sortable: false,
                    width: '30%',
                    text: 'Descrição',
                    value: 'descricao',
                    class: 'primary--text'
                },
                {
                    text: 'Linha fornecimento',
                    sortable: false,
                    value: 'situacao',
                    align: 'left',
                    width: '10%',
                    class: 'primary--text'
                },
                {
                    text: 'Unidade',
                    value: 'unidade',
                    sortable: false,
                    align: 'right',
                    width: '8%',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    align: 'right',
                    text: 'Qtd',
                    width: '5%',
                    value: 'quantidade',
                    class: 'primary--text'
                },
                {
                    value: 'tipo',
                    text: 'Tipo',
                    align: 'right',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
            ]
        },
        prefix(){
            return this.prefixOuSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixOuSuffixValor === '%' ? '%' : ''
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    },
    methods: {
        pegarTamanho() {
            this.tamanho = .120 * window.innerWidth
        }
    }
}
</script>

<style scoped lang="stylus">
.table-itens, .table-itens-manual
    border-top 1px solid #ebebeb
    padding 16px

@media (max-width 720px)
    .table-itens, .table-itens-manual
        padding 0

        td:nth-of-type(1):before
            content "Sequência:"

        td:nth-of-type(4)
            text-align left

        td:nth-of-type(5)
            text-align left

        td:nth-of-type(6)
            text-align left

    .table-itens
        td:nth-of-type(2):before
            content "Código:"

        td:nth-of-type(3):before
            content "Descrição:"

        td:nth-of-type(4):before
            content "Unidade:"

        td:nth-of-type(5):before
            content "Quantidade:"

        td:nth-of-type(6):before
            content "Estimado Unitário (R$):"

        td:nth-of-type(7):before
            content "Estimado Total (R$):"

        td:nth-of-type(7)
            text-align left

    .table-itens-manual
        td:nth-of-type(2):before
            content "Descrição:"

        td:nth-of-type(3):before
            content "Unidade:"

        td:nth-of-type(4):before
            content "Quantidade:"

        td:nth-of-type(5):before
            content "Estimado Unitário (R$):"

        td:nth-of-type(6):before
            content "Estimado Total (R$):"

        td:nth-of-type(3)
            text-align left
</style>
